import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { setTimeout$ } from '../core/common';
import { BehaviorSubject, interval, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthState } from '../states/auth.state';
import { SharedService } from './shared.service';
import { ActivityCriteria } from '../common';

@Injectable({
  providedIn: 'root'
})
export class ActivityService implements OnDestroy {
  private isOperator: boolean;
  constructor(private http: HttpClient, private sharedService: SharedService) {
    if (!sharedService.isBrowser) return;
    AuthState.user$.pipe(takeUntil(this.unsubscribe$)).subscribe(async user => {
      this.isOperator = user?.IsOperator || user?.IsKarpasha;
    });

    interval(10 * 60 * 1000).pipe(takeUntil(this.unsubscribe$)).subscribe(async () => {
      await this.getToDo();
    });
    setTimeout$(() => this.getToDo());
  }

  static karpashaActivityTypes = [
    { key: 'karpasha-job-note', title: 'یادداشت', isDone: true },
    { key: 'karpasha-job-call', title: 'تماس مجدد', isDone: false },
    { key: 'karpasha-job-track', title: 'پیگیری', isDone: false },
  ];

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }


  toDo$ = new BehaviorSubject(0);
  async getToDo() {
    if (!this.isOperator) return;
    const todo = await (this.http.get<number>(environment.app.apiUrl + `activity/todo`).toPromise());
    this.toDo$.next(todo);
  }
  search(criteria: ActivityCriteria, from = 0, limit = 30) {
    return this.http.post<any>(environment.app.apiUrl + `activity/search/${from}/${limit}`, criteria).toPromise();
  }

  save(activity: any, dispatch = true) {
    var result = this.http.post<any>(environment.app.apiUrl + `activity/save`, activity).toPromise();
    if (dispatch) result.then(() => this.sharedService.eventBus.emit('activity-refresh'));
    return result;
  }
}
